"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montevarchi": {
    "91377600": [{
      "hkey": "c694b4ef",
      "slug": "montevarchi",
      "name": "Montevarchi",
      "primary": true,
      "skipSearch": false
    }],
    "chiantigiana": [{
      "hkey": "c694b4ef",
      "slug": "montevarchi",
      "name": "Montevarchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82bcea4f": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "giglio": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montevarchi"
    }],
    "2483fef4": [{
      "hkey": "f0fd01db",
      "slug": "ginestra-pestello",
      "name": "Ginestra-Pestello",
      "primary": true,
      "skipSearch": false
    }],
    "ginestra": [{
      "hkey": "f0fd01db",
      "slug": "ginestra-pestello",
      "name": "Ginestra-Pestello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8fdd5183": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ipercoop": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montevarchi"
    }],
    "d2b426d9": [{
      "hkey": "02847c2c",
      "slug": "mercatale-valdarno",
      "name": "Mercatale Valdarno",
      "primary": true,
      "skipSearch": false
    }],
    "mercatale-torre": [{
      "hkey": "02847c2c",
      "slug": "mercatale-valdarno",
      "name": "Mercatale Valdarno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7e3cd2d2": [{
      "hkey": "c694b4ef",
      "slug": "montevarchi",
      "name": "Montevarchi",
      "primary": true,
      "skipSearch": false
    }],
    "miravalle": [{
      "hkey": "c694b4ef",
      "slug": "montevarchi",
      "name": "Montevarchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1ec03e3a": [{
      "hkey": "f0fd01db",
      "slug": "ginestra-pestello",
      "name": "Ginestra-Pestello",
      "primary": true,
      "skipSearch": false
    }],
    "pestello": [{
      "hkey": "f0fd01db",
      "slug": "ginestra-pestello",
      "name": "Ginestra-Pestello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montevarchi"
    }],
    "357840af": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "piscina": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montevarchi"
    }],
    "6da15bd7": [{
      "hkey": "74bf0a51",
      "slug": "noferi-lavatoio",
      "name": "Noferi-Lavatoio",
      "primary": true,
      "skipSearch": false
    }],
    "santomme-noferi": [{
      "hkey": "74bf0a51",
      "slug": "noferi-lavatoio",
      "name": "Noferi-Lavatoio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e81c1094": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "524c783a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montevarchi"
    }]
  }
};
exports["default"] = _default;